import { render, staticRenderFns } from "./SkipLink.vue?vue&type=template&id=ed509940&"
import script from "./SkipLink.ts?vue&type=script&lang=ts&"
export * from "./SkipLink.ts?vue&type=script&lang=ts&"
import style0 from "./SkipLink.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports